import { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import IconTickets from "../SvgIcons/IconTickets";
import api from "../../services/axios"; // ✅ import your axios instance
import "./style.css";

export default function NotificationDropdown({ show, onClose, notifications, setFetchNotification }) {
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        onClose();
      }
    };
    if (show) document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [show, onClose]);

  if (!show) return null;

  const markAsRead = async (id) => {
    try {
      const res = await api.post(`/notifications/${id}/read`);
      setFetchNotification(prev => prev + 1);
      onClose();
      // setNotifications((prev) =>
      //   prev.map((n) =>
      //     n.id === id ? { ...n, ...updatedNotification } : n
      //   )
      // );
    } catch (err) {
      console.error("Failed to mark notification as read:", err);
    }
  };


  return (
    <div className="notification-dropdown" ref={dropdownRef}>
      <h3 className="title">Notifications</h3>
      <ul className="list">
        {notifications.length > 0 ? (
          notifications.map((n, index) => (
            <li
              key={index}
              className={`item ${n.is_read === "no" ? "unread" : "read"}`}
            >
              <div className="icon"><IconTickets /></div>
              <div className="text">
                <p>
                  <Link
                    to={`/view-ticket-history/${n?.message?.split(" ")[0]}`}
                    style={{ color: "black", textDecoration: "none", fontWeight: "bold" }}
                  >
                    {n?.message?.split(" ")[0]}
                  </Link>
                  {" - "}
                  {n?.message?.split(" ").slice(1).join(" ")}{" "}
                  {" - "}
                  {n.Priority?.Name}
                </p>
                <div style={{display : "flex" , justifyContent : "space-between"}}>
                  <span>Agent: {n.Agent?.Agent_Name}</span>
                  {n.is_read === "no" && <span onClick={n.is_read === "no" ? () => markAsRead(n.id) : undefined} style={{color : 'Green' , cursor : "pointer"}}>mark as read</span>}
                </div>
              </div>
            </li>
          ))
        ) : (
          <li className="empty">No notifications</li>
        )}
      </ul>
    </div>
  );
}
